<template>
  <div :class="{ 'form-group': true, 'has-error': hasInvalidFeedback }">
    <label class="control-label" v-text="localLabel" v-if="localLabel"></label>
    <slot></slot>
    <div
      class="element__container-errors"
      v-if="hasInvalidFeedback && showError"
    >
      <ul class="parsley-errors-list filled">
        <li>{{ invalidFeedback }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { formErrorMixin } from "../../../mixins";
export default {
  mixins: [formErrorMixin],

  props: {
    label: { type: String, default: null },
    showError: { type: Boolean, default: true }
  },

  computed: {
    isChild() {
      return Boolean(this.$parent && this.$parent.isForm);
    },

    localLabel() {
      if (this.label != null) return this.label;
      var slot = null;
      var slot = this.fields.find(s => {
        s = s.vm;
        return s.isChild && s.label != null;
      });
      if (slot) {
        return slot.vm.label;
      }
      return null;
    },

    parentForm() {
      return this.isChild ? this.$parent : null;
    }
  },

  methods: {
    registerField(vm) {
      if (this.isChild) {
        this.parentForm.registerField(vm);
        this.fields.push({ name: vm.name, vm: vm });
      }
    }
  },

  data() {
    return {
      fields: [],
      isFormGroup: true
    };
  }
};
</script>
